import React from 'react';
import { MessageCircle } from 'lucide-react';
import { getWhatsAppUrl, scrollToEvaluation, trackPixelEvent, type PixelEvent } from '../lib/whatsapp';
type CTAAction = 'whatsapp' | 'scroll-to-evaluation';
interface CTAButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'nav';
  className?: string;
  showIcon?: boolean;
  action?: CTAAction;
  pixelEvent?: PixelEvent | null;
}
export function CTAButton({
  children,
  variant = 'primary',
  className = '',
  showIcon = true,
  action = 'whatsapp',
  pixelEvent = null
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold transition-all duration-200 ease-in-out text-center cursor-pointer';
  const variants = {
    primary: 'bg-accent hover:bg-accent-hover text-white rounded-xl px-6 py-4 text-lg shadow-lg shadow-accent/20 hover:shadow-accent/40 hover:-translate-y-0.5',
    secondary: 'bg-transparent border-2 border-white/20 hover:border-white/50 text-white rounded-xl px-6 py-4 text-lg hover:bg-white/5',
    nav: 'bg-accent hover:bg-accent-hover text-white rounded-lg px-4 py-2.5 text-sm shadow-md hover:shadow-lg'
  };
  const isWhatsApp = action === 'whatsapp';
  const showWhatsAppIcon = showIcon && isWhatsApp;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (pixelEvent) {
      trackPixelEvent(pixelEvent);
    }
    if (action === 'scroll-to-evaluation') {
      e.preventDefault();
      scrollToEvaluation();
    }
  };
  const content = <>
      {showWhatsAppIcon && <MessageCircle className={`mr-2 ${variant === 'nav' ? 'w-4 h-4' : 'w-5 h-5'}`} data-id="element-67" />}
      {children}
    </>;
  if (isWhatsApp) {
    return <a href={getWhatsAppUrl()} target="_blank" rel="noopener noreferrer" onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-68">
        {content}
      </a>;
  }
  return <a href="#StrategicEvaluation" onClick={handleClick} className={`${`${baseStyles} ${variants[variant]} ${className}`} pt-[10px] pb-[10px] mt-[10px] mb-[10px]`} data-id="element-69">
      {content}
    </a>;
}